import { apiRequest, handleCall } from 'syft-acp-core/api/call'

import type { FetchEmployerBlocksAction } from './actions'

/**
 * GET /api/v2/employers/:id/blocked_workers. `work_location_id` is forwarded as a
 * query arg; employerID stays on the path. `handleCall` keeps the request payload
 * so `entityReducer` can key the paginated set by `{ employerID, ...query }`.
 */
export const fetchEmployerBlocks = ({ payload }: FetchEmployerBlocksAction) =>
  new Promise((resolve, reject) => {
    const { employerID, ...reqArgs } = payload
    handleCall(
      apiRequest({
        path: `/employers/${employerID}/blocked_workers`,
        reqArgs,
      }),
      resolve,
      reject,
      true,
      payload,
    )
  })
